import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

declare var google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MAPS';
  page: any;
  clientId = '515968823132-e99if4giu1nf2m98ckkf8ferfiupoa99.apps.googleusercontent.com';

  constructor(
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private ngZone: NgZone
  ) {
    this.route.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        this.page = data.state.root.firstChild.data.page;
      }
    });
    
  }

  ngOnInit(): void {

  }
}



